import { Redirect, Route } from 'react-router-dom';

function ProtectedRoute({ children, ...rest }) {
  const user = JSON.parse(localStorage['test-optimize-user'] || null);
  return <Route {...rest} render={() => (user?.access_token ? children : <Redirect to="/" />)} />;
}

export default ProtectedRoute;
